import React from 'react';
import PropTypes from 'prop-types';
import SMStream from '../streams/SMStream2';

const smWidgetsStandings = ({ tournamentId, teamId, seasonId }) => {
    return [
        {
            name: 'TournamentTableSMWidget',
            props: {
                teamId,
                seasonId,
                tournamentId,
                qualRel: false
            }
        },
        {
            name: 'TournamentTableSMWidget',
            props: {
                teamId,
                seasonId,
                tournamentId,
                qualrel: true,
                full: true
            }
        },
        {
            name: 'LeagueTrackerSMWidget',
            props: {
                team1Id: teamId,
                seasonId,
                tournamentId
            }
        }
    ];
};

const smWidgetsMatches = ({ teamId }) => {
    return [
        {
            name: 'TeamMatchesSMWidget',
            props: {
                teamId,
                status: 'notstarted',
                limit: 5
            }
        },
        {
            name: 'TeamMatchesSMWidget',
            props: {
                teamId,
                status: 'finished',
                limit: 5
            }
        }
    ];
};

const smWidgetsBest = ({ teamId }) => {
    return [
        {
            name: 'TeamSeasonTopScorersSMWidget',
            props: {
                teamId,
                incidentType: 'goals',
                activePlayers: true,
                layout: 2
            }
        },
        {
            name: 'TeamSeasonTopScorersSMWidget',
            props: {
                teamId,
                incidentType: 'goals',
                activePlayers: true,
                layout: 1
            }
        }
    ];
};
function TeamSeasonHomeSMB({ params }) {
    return (
        <div>
            <SMStream smWidgets={smWidgetsStandings(params)} title="Standings" />
            <SMStream smWidgets={smWidgetsMatches(params)} title="Matches" />
            <SMStream smWidgets={smWidgetsBest(params)} title="Best players" />
        </div>
    );
}

TeamSeasonHomeSMB.propTypes = {
    params: PropTypes.shape({
        tournamentId: PropTypes.string.isRequired,
        teamId: PropTypes.string.isRequired,
        seasonId: PropTypes.string.isRequired
    }).isRequired
};

export default TeamSeasonHomeSMB;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/TeamSeasonHomeSMB.js
 **/